<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <breadcrumb>
          <span slot="one">系统管理</span>
          <span slot="two">角色管理</span>
          <span slot="three">{{typeText}}</span>
        </breadcrumb>
        <div style="float:right;margin-top:-26px">
          <el-button type="primary" size="small" @click="actGoBack">返回</el-button>
        </div>
      </div>

      <el-form ref="form" :model="detailForm" label-width="90px" :disabled="isView" :rules="rules"
        v-loading="detailDataLoading">
        <el-form-item label="角色名称" prop="roleName">
          <el-input style="width: 300px;" v-model="detailForm.roleName" v-loading="roleNameLoading"></el-input>
        </el-form-item>
        <el-form-item label="角色代码" prop="roleCode">
          <el-input style="width: 300px;" v-model="detailForm.roleCode" v-loading="roleCodeLoading" :disabled="!isAdd">
          </el-input>
        </el-form-item>
      </el-form>

      <div style="margin-left: 12px;color: #606266;margin-top: 40px;font-size: 14px;font-weight: 600;">权限配置</div>

      <div class="table-wrapper">
        <div v-loading="dataListLoading" class="table">
          <div class="header-wrapper">
            <table class="header">
              <tr>
                <th width="30%">菜单权限</th>
                <th width="70%">操作权限</th>
              </tr>
            </table>
          </div>
          <el-checkbox-group v-model="detailForm.permissionIds">
            <div class="body-wrapper">
              <table class="body">
                <span style="display: block;" v-for="item in permissionList" :key="item.menuPermission.id">
                  <tr class="row striped">
                    <td>
                      <el-checkbox :disabled="item.menuPermission.status==='0'" :label="item.menuPermission.id">
                        {{item.menuPermission.name}}
                      </el-checkbox>
                    </td>
                    <td>
                      <el-checkbox v-for="btnItem in item.btnPermission" :key="btnItem.name" :label="btnItem.id"
                        :disabled="btnItem.status==='0'" style="margin-top: 6px;margin-bottom: 6px;">
                        {{btnItem.name}}
                      </el-checkbox>
                    </td>
                  </tr>
                  <tr class="row" v-for="childrenItem in item.children" :key="childrenItem.menuPermission.id">
                    <td style="padding-left: 150px;">
                      <el-checkbox :disabled="childrenItem.menuPermission.status==='0'"
                        :label="childrenItem.menuPermission.id">
                        {{childrenItem.menuPermission.name}}
                      </el-checkbox>
                    </td>
                    <td>
                      <el-checkbox v-for="chilrenBtnItem in childrenItem.btnPermission" :key="chilrenBtnItem.name"
                        :label="chilrenBtnItem.id" :disabled="chilrenBtnItem.status==='0'" style="margin-top: 6px;margin-bottom: 6px;">
                        {{chilrenBtnItem.name}}
                      </el-checkbox>
                    </td>
                  </tr>
                </span>
              </table>
            </div>
          </el-checkbox-group>
        </div>
      </div>

      <div class="footer-btn">
        <el-button type="primary" @click="addOrEditHandle" :loading="saveLoading">保 存</el-button>
        <el-button type="warning" @click="actGoBack">取 消</el-button>
      </div>

    </el-card>
  </div>
</template>

<script>
  import mixinFormModule from '@/mixins/form-module/primary.js'
  export default {
    mixins: [mixinFormModule],
    data() {
      return {
        mixinFormModuleOptions: {
          detailDataURL: this.$api.roleDetailDataURL,
          addDataURL: this.$api.roleAddURL,
          editDataURL: this.$api.roleEditURL
        },
        detailForm: {
          permissionIds: []
        },
        permissionList: [],
        roleNameLoading: false,
        roleCodeLoading: false,
        dataListLoading: false,
        rules: {
          roleName: [
            { required: true, message: '请输入角色名称', trigger: ['blur', 'change'] },
            { validator: this.validateRoleName, trigger: ['blur'] }
          ],
          roleCode: [
            { required: true, message: '请输入角色代码', trigger: ['blur', 'change'] },
            { validator: this.validateRoleCode, trigger: ['blur'] }
          ]
        },
      }
    },

    created() {
      this.getDetailData()
      this.getDataList()
    },

    methods: {
      async getDataList() {
        this.dataListLoading = true
        try {
          let res = await this.$api.getAllPermission()
          this.dataListLoading = false
          if (res.success) {
            this.permissionList = res.result
          } else {
            this.$notify.error({ title: '系统提示', message: res.message })
          }
        } catch (e) {
          this.dataListLoading = false
        }
      },

      async validateRoleName(rule, val, callback) {
        this.roleNameLoading = true
        try {
          let res = await this.$api.roleFieldVerifyRepeat(this.id, val, 'ROLE_NAME')
          this.roleNameLoading = false
          if (res.result) {
            callback(new Error('角色名称已存在'))
          } else {
            callback()
          }
        } catch (e) {
          this.roleNameLoading = false
        }
      },

      async validateRoleCode(rule, val, callback) {
        this.roleCodeLoading = true
        try {
          let res = await this.$api.roleFieldVerifyRepeat(this.id, val, 'ROLE_CODE')
          this.roleCodeLoading = false
          if (res.result) {
            callback(new Error('角色代码已存在'))
          } else {
            callback()
          }
        } catch (e) {
          this.roleCodeLoading = false
        }
      }
    }
  }
</script>


<style scoped lang='less'>
  .table-wrapper,
  .table .header-wrapper,
  .table .body-wrapper,
  .table .header,
  .table .body {
    width: 100%;
  }

  .table {
    margin: 25px 12px;
    border-radius: 4px;
    border: 2px solid #EBEEF5;
  }

  .table tr {
    display: inline-table;
    width: 100%;
  }

  .table .row {
    border-bottom: 1px solid #EBEEF5;
  }

  .table .header-wrapper {
    background: #ECEFF2;
  }

  .table .header th {
    padding: 12px 100px;
    background: #ECEFF2;
    color: #606266;
    text-align: left;
  }

  .table .body td {
    padding: 12px 20px 12px 100px;
    text-align: left;
  }

  .table .body td:first-of-type {
    width: 30%;
  }

  .table .body tr.striped {
    background: #FAFAFA;
  }
</style>
